export default __webpack_public_path__ + "static/media/img-7.3c9c4486.png";